module.exports = __webpack_public_path__ + "ml.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ml.svg
// module id = 692
// module chunks = 0